import { Button, Divider, Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { useClientFormContext } from '../../views/Client/ClientFormContext';

interface SubmitButtonProps {
    formId: string;
    form: FormInstance;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ formId, form }: SubmitButtonProps): React.ReactElement => {
    const { formConfig, mode, resetForm } = useClientFormContext();

    return (
        <Form.Item>
            {formConfig.isAddMode && (
                <>
                    <Button
                        htmlType="reset"
                        title="Reset"
                        id="form__btn-reset"
                        name="form__btn-reset"
                        onClick={(): void => {
                            resetForm(form);
                        }}
                    >
                        Reset
                    </Button>
                    <Divider type="vertical" />
                </>
            )}
            <Button
                className="btn-primary bg-primary text-white"
                htmlType="submit"
                id="form__btn-submit"
                name="form__btn-submit"
                form={formId}
                title={formConfig.setupModes[mode].submitButtonTitle}
            >
                {formConfig.setupModes[mode].submitButtonTitle}
            </Button>
        </Form.Item>
    );
};

export default SubmitButton;
